import axios, { AxiosRequestConfig, GenericAbortSignal } from 'axios';
import { prop } from 'ramda';

import { RootConfig } from '../../../types/config.types';
import { getLanguageFromUrlParams } from '../I18nLoader/I18nLoader.utils';

import { ApiErrors, ApiRequestConfig, ApiResponse } from './ApiRequest.types';
import { securityParser } from './ApiRequest.utils';

// import { enableMockResponse } from './ApiRequest.mockData';
// // add extra flag
// const development: boolean = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

axios.defaults.withCredentials = true;
class ApiRequest {
  public baseUrl!: string;

  public headers!: Record<string, string>;

  public apiRequestAxios = axios;

  public constructor(config: ApiRequestConfig) {
    if (!config) {
      return;
    }

    // if (development) {
    // enableMockResponse(this.apiRequestAxios);
    // }

    this.baseUrl = config.baseURL || window.location.origin.toString();

    this.apiRequestAxios.interceptors.request.use(
      (apiConfig) => {
        const updateConfig = { ...apiConfig };

        // can been cleaned if dcp session is actieve
        if (updateConfig.headers) {
          if (!updateConfig.headers['Content-Type']) {
            updateConfig.headers['Content-Type'] = 'application/json';
          }
          // TODO - get from cookie - see homebank
          updateConfig.headers['Accept-Language'] = getLanguageFromUrlParams(
            window.location.pathname
          );
        }

        return updateConfig;
      },
      (error) => Promise.reject(error)
    );

    this.apiRequestAxios.interceptors.response.use(
      (responseBody) => {
        const formattedBody = { ...responseBody, parsedBody: responseBody.data };

        if (prop('errors', formattedBody.data)) {
          throw formattedBody;
        }

        return formattedBody;
      },
      (error: ApiErrors) => {
        throw error;
      }
    );
  }

  public getFullPath(path: string): string {
    return this.baseUrl + path;
  }

  public get<T>(path: string, signal?: GenericAbortSignal): Promise<ApiResponse<T>> {
    return this.apiRequestAxios.get(this.getFullPath(path), { data: undefined, signal });
  }

  public post<P extends object, T>(
    path: string,
    body: P,
    headers?: AxiosRequestConfig['headers'],
    signal?: GenericAbortSignal
  ): Promise<ApiResponse<T>> {
    return this.apiRequestAxios.post<P, ApiResponse<T>>(
      this.getFullPath(path),
      securityParser(body),
      { headers, signal }
    );
  }

  public put<P, T>(path: string, body: P, signal?: GenericAbortSignal): Promise<ApiResponse<T>> {
    return this.apiRequestAxios.put<P, ApiResponse<T>>(
      this.getFullPath(path),
      securityParser(body),
      { signal }
    );
  }

  public delete<T>(path: string, signal?: GenericAbortSignal): Promise<ApiResponse<T>> {
    return this.apiRequestAxios.delete(this.getFullPath(path), { data: {}, signal });
  }
}

// eslint-disable-next-line import/no-mutable-exports
export let apiRequest: ApiRequest;

export const initApiRequest = (config: RootConfig): void => {
  if (!apiRequest) {
    apiRequest = new ApiRequest({
      baseURL: config.apiHost,
    });
  }
};
